import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import posthog from 'posthog-js';

import { emailSchema } from '../../../utils/schemas';
import Modal from '../../Modal/Modal';
import { useCaptureStopBangResultsMutation } from '../../../app/services/auth';
import { useAssessmentContext } from '../../../providers';

const schema = yup.object({ email: emailSchema });

function CaptureStopbangResults({ modalOpen, setModalOpen }) {
    const { answers } = useAssessmentContext();
    const [captureStopBangResults, { isSuccess }] = useCaptureStopBangResultsMutation();

    async function handleSubmit(data, { setSubmitting, resetForm }) {
        try {
            posthog?.capture('Emailed stopabang results');

            await captureStopBangResults({ email: data.email, stopBang: answers });
            resetForm();
        } catch (error) {
            toast.error('Something went wrong, please try again');
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <Modal
            key="capture-results-modal"
            showClose
            isOpen={modalOpen}
            closeHandler={() => setModalOpen(false)}>
            {isSuccess ? (
                <p key="capture-results-success" className="font-bold text-gem-green">
                    Your results should be in your email shortly!
                </p>
            ) : (
                <Formik
                    key="capture-results-form"
                    initialValues={{ email: '' }}
                    validationSchema={schema}
                    onSubmit={handleSubmit}>
                    {({ isSubmitting }) => (
                        <Form className="flex flex-col mt-2 gap-y-4 ph-no-capture">
                            <p className="font-bold text-gem-green">
                                Enter your email to receive your results
                            </p>
                            <Field
                                className="border rounded p-4"
                                id="email"
                                name="email"
                                type="email"
                                placeholder="Enter your email"
                            />
                            <ErrorMessage name="email" component="div" style={{ color: 'red' }} />
                            <button className="btn-primary" type="submit" disabled={isSubmitting}>
                                Submit
                            </button>
                        </Form>
                    )}
                </Formik>
            )}
        </Modal>
    );
}

export default CaptureStopbangResults;
